// Identical to the desktop's ThemeToggleButton — moon/sun switch in the top-right.
import { MoonIcon, SunIcon } from "./Icons";

interface ThemeToggleButtonProps {
	className?: string;
	isLightTheme: boolean;
	isPending?: boolean;
	onToggle: () => void;
}

export const ThemeToggleButton = ({
	className,
	isLightTheme,
	isPending = false,
	onToggle,
}: ThemeToggleButtonProps) => {
	const Icon = isLightTheme ? MoonIcon : SunIcon;
	const title = isLightTheme ? "Switch to dark theme" : "Switch to light theme";

	return (
		<button
			className={[
				"tg-btn-icon tg-btn-secondary rounded-xl transition disabled:cursor-wait disabled:opacity-60",
				isLightTheme ? "tg-theme-toggle-moon" : "tg-theme-toggle-sun",
				className,
			]
				.filter(Boolean)
				.join(" ")}
			type="button"
			onClick={onToggle}
			disabled={isPending}
			aria-label={title}
			title={title}
		>
			<Icon className={`h-4.5 w-4.5 ${isPending ? "animate-pulse" : ""}`} />
		</button>
	);
};
